import React from 'react'
import { Outlet } from 'react-router-dom'
import '../../styles/pages/page-common.css'
import '../../styles/pages/settings.css'

/** Layout для /settings. Заголовки — через PageSection на каждой странице. */
export default function SettingsLayout() {
  return (
    <div className="settings-page">
      <Outlet />
    </div>
  )
}
